import React, { useEffect, useState } from "react";
import { ReactSVG } from "react-svg";
import "./index.css";
import "./menu.css";
import "../../../stylesheets/styles.css";
import { Link, useLocation } from "react-router-dom";



const Header= ({ isAuthenticated, loading }) => {
 const [menuOpen, setMenuOpen] = useState(false);
const location = useLocation();

// Auto-close when route changes
useEffect(() => { setMenuOpen(false); }, [location.pathname]);

// Delegate click inside the nav: if a link is clicked, close
const onNavClick = (e) => {
  const a = (e.target ).closest("a");
  if (a) setMenuOpen(false);
};
  // Fecha o menu ao ir para desktop e trava o scroll quando aberto no mobile
  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth >= 769 && menuOpen) setMenuOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [menuOpen]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  return (
    <header className="header">
      <div className="topbar">
        <div className="navbar">
          <Link to="/" className="topbar-brand">
            <img
              src="../../static/assets/images/logo.svg"
              className="logo"
              alt="Logo"
            />
            <span className="postsheet">PostSheet</span>
          </Link>

          {/* Botão burger (só aparece no mobile via CSS) */}
          <button
            type="button"
            aria-label={menuOpen ? "Fechar menu" : "Abrir menu"}
            aria-expanded={menuOpen}
            aria-controls="primary-nav"
            className="menu-icon-btn"
            onClick={() => setMenuOpen((v) => !v)}
          >
            {!menuOpen ? (
              <ReactSVG
                src="../../static/assets/images/menu-open.svg"
                className="image w-7 h-7"
              />
            ) : (
              <ReactSVG
                src="../../static/assets/images/menu-close.svg"
                className="burger-menu"
              />
            )}
          </button>

          {/* Links (horizontais no desktop / painel deslizante no mobile) */}
          <nav
            id="primary-nav"
            className={`nav-links ${menuOpen ? "open" : ""}`}
            role="navigation"
             onClick={onNavClick}    
          >
            <Link to="/docs" className="menu-option">
              Help Docs
            </Link>
            <Link to="/guides" className="menu-option">
              Guides
            </Link>
            <a
              href="https://postsheetblog.com"
              className="menu-option"
              rel="noreferrer"
            >
              Blog
            </a>
            <Link to="/pricing" className="menu-option">
              Pricing
            </Link>

            {loading ? (
              <div className="menu-option">Loading...</div>
            ) : !isAuthenticated ? (
              <Link to="/signin" className="menu-option">
                Sign In
              </Link>
            ) : (
              <Link to="/app/jobs/new?step=0" className="menu-option">
                Dashboard
              </Link>
            )}
          </nav>
        </div>
      </div>

      {/* Backdrop no mobile */}
      {menuOpen && <div className="backdrop" onClick={() => setMenuOpen(false)} />}
    </header>
  );
};

export default Header;
